import useAuthenticate from './use-authentication';

export { useAuthenticate };

export default useAuthenticate;
